import React from "react";
import { Hero } from "./components/Hero";
import { ProblemSection } from "./components/ProblemSection";
import { TechniquesSection } from "./components/TechniquesSection";
import { CollectionSection } from "./components/CollectionSection";
import { BonusSection } from "./components/BonusSection";
import { OfferSummary } from "./components/OfferSummary";
import { UsageSection } from "./components/UsageSection";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31agpgrwy8ll1">
      <div className="border-b border-line bg-paper px-4 py-2.5 text-center font-display text-sm text-ink sm:text-base" data-id="element-1" data-mp="31ctaxf1x1e2u">
        Más de 50 técnicas creativas para explorar tus emociones, encontrar calma y conectar contigo
      </div>
      <main data-id="element-2" data-mp="23vupqgmff2wq">
        <Hero data-id="element-3" data-mp="23w4c7u89irxo" />
        <ProblemSection data-id="element-4" data-mp="23ujlkfp2jt53" />
        <TechniquesSection data-id="element-5" data-mp="23t8iki3g6pf1" />
        <CollectionSection data-id="element-6" data-mp="3ik7fqfdqo9q4" />
        <BonusSection data-id="element-7" data-mp="3iiweonbohg2p" />
        <OfferSummary data-id="element-8" data-mp="3ijfthv617oci" />
        <UsageSection data-id="element-9" data-mp="3ii4s22026sok" />
        <Faq data-id="element-10" data-mp="3mlat8v8bdto6" />
        <FinalCta data-id="element-11" data-mp="3mkrbpfmkt7ao" />
      </main>
      <Footer data-id="element-12" data-mp="3mjztd6hzp62c" />
    </div>;
}